var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-pdf"},[_c('iframe',{attrs:{"src":_vm.$pdf + '?file=' + encodeURIComponent(_vm.file)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }